<template>
    <span>
      <template v-if="url">
        <!-- {{url}} -->
        <video class="video" :id="idElemento()" width="100%" height="auto" controls></video>
        <!--
          <video v-if="!esProtocoloHTTPS" class="video" :id="idElemento()" width="100%" height="auto" controls></video>
          <div v-else class="d-flex flex-column justify-center align-center" style="width: 100%; height: 250px; background: #F2F2F2;">
            <v-icon x-large color="red">mdi-video-off</v-icon>Vídeo no disponible sobre HTTPS
          </div>
         -->
      </template>
      <template v-else>
        <div class="d-flex flex-column justify-center align-center" style="width: 100%; height: 250px; background: #F2F2F2;">
          <v-icon x-large>mdi-video-off</v-icon>Fuente de vídeo no especificada
        </div>
      </template>
    </span>
</template>

<script>
import { uniqueId } from "@/util";
import Hls from "hls.js";

export default {
  props: {
    url: {
      type: String,
      required: true,
      default: "" // http://dev.equinsaparking.com:38898/path/stream.m3u8
    }
  },
  data() {
    this.hls = null;
    return {
    }
  },
  computed: {
    esProtocoloHTTPS() {
      return location.protocol.localeCompare ('https:', undefined, { sensitivity: "accent" }) == 0;
    }
  },
  methods: {
    idElemento() {
      if (!this.uid)
        this.uid = uniqueId();
      return 'Video_' + this.uid;
    }
  },
  mounted() {
    if (!this.url) return;

    var video = document.getElementById (this.idElemento());

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = this.url;
      video.addEventListener('canplay', function () {
        video.play();
      });
    } else {
      if (Hls.isSupported()) {
        this.hls = new Hls({
           "enableWorker": true,
           "maxBufferLength": 1,
           "liveBackBufferLength": 0,
           "liveSyncDuration": 0,
           "liveMaxLatencyDuration": 5,
           "liveDurationInfinity": true,
           "highBufferWatchdogPeriod": 1,
        });
        this.hls.loadSource (this.url);
        this.hls.attachMedia (video);
        this.hls.on(Hls.Events.MEDIA_ATTACHED, function () {

          video.play();
        });
      }
    }
  },
  beforeDestroy() {
    if (this.hls)
      this.hls.destroy();
  }
};
</script>

<style>
.video {
  background: black url('~@/assets/loader.gif') center no-repeat;
  margin: 0px 0px -7px 0px;
}
</style>